import script from "./NovuInbox.vue?vue&type=script&setup=true&lang=js"
export * from "./NovuInbox.vue?vue&type=script&setup=true&lang=js"

import "./NovuInbox.vue?vue&type=style&index=0&id=2ba31364&lang=css"

const __exports__ = script;

export default __exports__